module.exports = __webpack_public_path__ + "assets/fb27eb45d78f48c003effb0d5aa22451.mp3";